var _circle, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleWithTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 45,
    stroke: "currentColor",
    strokeWidth: 5,
    fill: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "60%",
    textAnchor: "middle",
    stroke: "#000000",
    fontSize: "3rem",
    fontFamily: "Lexend",
    strokeWidth: "0.1rem",
    dy: ".3rem"
  }, "2")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWithTwo);
export default __webpack_public_path__ + "static/media/circleWithTwo.5dd8d913bdcf78c24cbc67e5f891d7db.svg";
export { ForwardRef as ReactComponent };